<template>
	<b-row class="doc_title" v-if="kadastr != null">
		<b-col sm="6">
			<div class="kadastr_field mb-4" v-if="kadastr != null">
				<b-form-text :id="'lbk_' + kadastr.type + kadastr.id">
					{{kadastr.name}}
					<span class="color-danger-500" > * </span>
				</b-form-text>

				<the-mask :mask="['##########:##:###:####']"
						  placeholder="##########:##:###:####"
						  name="text"
						  class="form-control form-control-sm fs-xl"
						  type="text"
						  @input="load_pai(kadastr)"
						  v-model="kadastr.value"
						  :masked="true"/>
			</div>

			<b-overlay :show="loading_unit" rounded="sm">
				<div class="tab_pai_field mb-4" v-for="field in addon_fields_draw" :key="field.id">
					<b-form-text :id="'help_' + field.type + field.id">
						{{field.name}}
						<span class="color-danger-500" v-if="field.required == 1"> * </span>
					</b-form-text>
					<b-form-input
						type="text"
						class="fs-xl"
						v-if="field.type === 'string_input'"
						:state="is_valid_field(field)"
						v-model="field.value"
						:disabled="!is_valid_kadastr"
						:id="field.type + field.id"
						size="sm" >
					</b-form-input>

					<b-form-radio-group
						id="btn-radios-1"
						v-if="field.type === 'yes_no'"
						v-model="field.value"
						button-variant="outline-primary"
						:options="[
										  { text: 'Так', value: 'yes' },
										  { text: 'Ні', value: 'no' }]"
						name="radios-btn-default"
						buttons
					></b-form-radio-group>
				</div>

				<div class="1c_fields" >
					<div class="descriptions border  p-2 border-success" v-if="pai_1c_active != null" >
						<div class="blck p-1" v-if="can_show_1c_field(info)" v-for="(info) in pai_fields_active">
							<b>{{ info.field_name}}</b>
							= {{info.field_val}}
						</div>
					</div>
				</div>
			</b-overlay>
		</b-col>

		<b-col sm="6" class="border-left">
			<div class="pai_info" v-if="pai_info.is_load && pai_info_data.length > 0">
				<h3 class="p-2">Дані 1С + Panorama</h3>
				<div class="bg-light rounded-top mb-2" v-for="(pai,idx) in this.pai_info.data">
					<div id="js_list_accordion" class="accordion accordion-hover accordion-clean ">
						<div class="card ">
							<div class="card-header border">

								<a v-on:click="setActivePai(idx)" class="card-title" :class="{
									'collapsed' : !is_active_pai(idx),
									'cant_select' : !is_can_select(idx)
								}">
									<i class="fal fa-globe-americas width-2 fs-xl"></i>
									{{getOwner1c(pai)}}
									<div class="ml-2">
										<small>{{pai.params.kadastr}}</small>
									</div>
								</a>
							</div>

							<div class="card-body" v-if="has_preview_info(pai)">
								<div class="c_fields_preview" >
									<div class="descriptions " v-if="pai_1c_preview_active != null" >
										<legend class="small">
											Превю
										</legend>
										<div class="blck p-1" v-if="can_show_1c_field(info)" v-for="(info) in pai_fields_1c_active">
											<b>{{ info.field_name}}</b>
											= {{info.field_val}}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

			</div>

			<div class='color-danger-300 fs-xl text-center' v-else>
				Увага! Дана ЗД не перебуває в оренді підприємств ГК ІМК. Її придбання потребує отримання відмови від переважного права на придбання від поточного орендаря ЗД, а також передбачає подальші орендні взаємовідносини покупця із поточним орендарем ЗД – сторонньою компанією, яка не входить до складу ГК ІМК!
			</div>


		</b-col>
	</b-row>
</template>

<script>
export default {
	name: "land_pai",


	props : {
		owner_field : {
			type : Object
		},

		pai_item : {
			type : Object
		}
	},

	data() {
		return {

			preview_1c_idx : -1,

			loading_unit: false,

			pai_info: {
				"is_load": false,
				"data": []
			},

			disabled_draw_fields : [
				'pole1koordynaty',
				'pole2koordynaty',
				'pole3koordynaty',
				'pole4koordynaty',
				'pole5koordynaty',
			]
		}
	},

	methods : {

		has_preview_info(pai) {
			let has = false;
			try {
				if (this.pai_1c_preview_active != null) {
					if (pai.params.kontragent == this.pai_1c_preview_active.params.kontragent) {
						has = true;
					}
				}
			}
			catch(e) {
				console.log(e);
			}

			return has;

		},

		can_show_1c_field(item) {
			let can_show = true;
			this.disabled_draw_fields.map(type => {
				if(item.field_type === type) {
					can_show = false;
				}
			})

			return can_show;
		},

		getOwner1c(field) {
			let kontr = '';
			try {
				if (field.hasOwnProperty('data_1c')) {
					let p_1c = field.data_1c;
					p_1c.map(item => {
						if(item.field_type == 'Kontrahent') {
							kontr = item.field_val;
						}
					});

					//return p_1c['Контрагент'];
				}
			}
			catch (e) {

			}
			return kontr;
		},

		is_can_select (idx) {
			if(this.owner_field.hasOwnProperty("value") && this.owner_field.value != undefined && this.owner_field.value.trim().length > 0) {
				return this._is_pai_inside_owner(this.pai_info.data[idx]);
			}
			return true;
		},


		_is_pai_inside_owner (pai) {
			if(this.owner_field.hasOwnProperty("value") && this.owner_field.value != undefined) {
				try {
					if (pai.params.kontragent === this.owner_field.value) {
						return true;
					}
				}
				catch (e) {

				}
			}
			return false;
		},

		is_active_pai(idx) {
			if(this.owner_field.hasOwnProperty("value") ) {
				return this._is_pai_inside_owner(this.pai_info.data[idx]);
			}
			return false;
		},

		setActivePaiByOwner() {
			let found_idx = 0;
			let has_def = false;

			try {
				let idx = 0;
				this.pai_info.data.map(pai => {
					if (pai.hasOwnProperty('params') && pai.params.hasOwnProperty("kontragent")) {
						let kontragent = pai.params.kontragent;
						console.log("%c✔ Owner", "color: #ffc241",kontragent);
						if(this.owner_field.value == kontragent) {
							console.log("Found",idx,pai);
							has_def = true;
							found_idx = idx;
						}
					}
					idx++;
				});

				if (has_def) {
					console.log("Found", found_idx);
					this.setActivePai(found_idx);
				}
			}

			catch (e) {
				console.log(e);
			}
		},

		setActivePai (idx) {
			let active_field = this.pai_info.data[idx];
			this.preview_1c_idx = -1;

			if(this.is_can_select(idx)) {
				try {
					this.owner_field.value = active_field.params.kontragent;
				}
				catch (e) {

				}
				this.push_pai_infields();
			}
			this.preview_1c_idx = idx;
		},
		push_pai_infields() {
			//set Owner
			let data_pai = this.pai_1c_active;
			console.log("%c✔ push in fields", "color: #ffc241");

			try {
				if (this.pai_info.is_load) {
					//same name
					this.addon_fields_draw.map(item => {
						if (data_pai.params.hasOwnProperty(item.field_type)) {
							item.value = data_pai.params[item.field_type];
						}
					});

					try {
						if (data_pai.params.hasOwnProperty("kontragent")) {
							if (this.owner_field.hasOwnProperty("field_type")) {
								this.owner_field.value = data_pai.params.kontragent;
							}
						}
					}
					catch (e) {

					}
				}
			}

			catch (e) {

			}
			//this.load_map();
		},

		is_valid_field(field) {
			if(parseInt(field.required) == 1) {
				if(field.type == 'string_input') {
					return field.value.toString().length  > 0;
				}
				return false;
			}

			return true;
		},

		clean_user_inp() {
			this.addon_fields_draw.map(item => {
				item.value = '';
			});
		},
		async load_pai(field) {
			this.loading_unit = false;
			if(this.is_valid_kadastr) {
				this.loading_unit = true;
				this.clean_user_inp();

				await api.post('/pai_info',{
					"kadastr" : field.value,
					"source" : '1c'
				}).then(({data}) => {
					console.log("1c",data);
					this.loading_unit = false;
					this.pai_info.is_load = true;
					this.pai_info.data = data.data

					if(this.pai_info.data.length > 0) {
						this.pai_info.data.map(item => {
							item.is_active = false;
							item.is_open = false;
						});
						this.setActivePaiByOwner();
					}
				}).catch(err => {
					this.pai_info.is_load = false;
					this.loading_unit = false;
					//EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name})
				});
			}
		},
	},


	computed : {

		addon_fields() {
			try {
				return this.pai_item.fields;
			}
			catch (e) {

			}
			return [];
		},
		addon_fields_draw() {
			return this.addon_fields.filter(item => item.type !== "kadastr");
		},

		pai_fields_active() {
			let fields = [];
			if(this.pai_1c_active != null && this.pai_1c_active.hasOwnProperty("data_1c")) {
				return this.pai_1c_active.data_1c;
			}
			return fields;
		},

		pai_fields_1c_active() {
			let fields = [];
			if(this.pai_1c_preview_active != null && this.pai_1c_preview_active.hasOwnProperty("data_1c")) {
				return this.pai_1c_preview_active.data_1c;
			}
			return fields;
		},

		pai_1c_preview_active() {
			if(this.preview_1c_idx >= 0) {
				return this.pai_info.data[this.preview_1c_idx];
			}

			return null;
		},

		pai_1c_active () {
			let active = null;
			try {
				this.pai_info_data.map(item => {
					if (item.params.kontragent === this.owner_field.value) {
						active = item;
					}
				});
			}
			catch (e) {
				console.log(e);
			}
			return active;
		},

		pai_info_data() {
			if(this.pai_info.is_load) {
				return this.pai_info.data;
			}
			return [];
		},

		kadastr() {
			let field = null;
			if(this.addon_fields.length > 0 ) {
				this.addon_fields.map(item => {
					if(item.type === 'kadastr') {
						field = item;
					}
				})
			}
			return field;
		},

		is_valid_kadastr() {
			return this.kadastr.type === "kadastr" && this.kadastr.value.length === 22;
		},
	}
}
</script>

<style scoped>
	.cant_select {
		border: 1px solid red;
	}

	.c_fields_preview {
		height: 250px;
		overflow: auto;
	  }
</style>
